import { Select } from '@base-ui/react/select'
import { twMerge } from 'tailwind-merge'
import { scrollArrowClass } from './scroll-arrow-class'

interface SelectScrollUpArrowProps {
  className?: string
}

function SelectScrollUpArrow({ className, ...props }: SelectScrollUpArrowProps) {
  return <Select.ScrollUpArrow className={twMerge(scrollArrowClass, className)} {...props} />
}

export { SelectScrollUpArrow }
